import React from 'react'
import './Card.css';
import comingsoon from '../Components/images/wallpaper.png'
import { FaArrowLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Card = () => {
  return (
      <div className='paper'>
        <div className="Wallpaper">
        <div className="top-left-containerr">
        <Link to="/" className="top-left-btn">
          <FaArrowLeft />
        </Link>
      </div>
          <img src={comingsoon} alt='coming soon' height={630} width={700} />
        </div>
      </div>
   
  )
}

export default Card;
